import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sort',
  templateUrl: './sort.component.html'
})

export class SortComponent {
  @Input() field: string;
  @Input() sortValue: string;

  @Output() readonly sort: EventEmitter<any> = new EventEmitter<any>();

  onSort(): void {
    const sort = (this.sortValue === 'ASC') ? 'DESC' : 'ASC';
    this.sort.emit({sort, sortField: this.field});
  }
}